// directives/animateOnScroll.ts
import type { DirectiveBinding, ObjectDirective } from "vue"

interface HTMLElementWithObserver extends HTMLElement {
    _observer?: IntersectionObserver
}

type AnimateOptions = {
    enterClass?: string
}

const animateOnScroll: ObjectDirective = {
    mounted(
        el: HTMLElementWithObserver,
        binding: DirectiveBinding<AnimateOptions>
    ) {
        const animationClass = binding.value?.enterClass || "fade-in"

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    el.classList.add(...animationClass.split(" "))
                    observer.unobserve(el)
                }
            },
            { threshold: 0.1 }
        )

        el._observer = observer
        observer.observe(el)
    },

    unmounted(el: HTMLElementWithObserver) {
        if (el._observer) {
            el._observer.disconnect()
        }
    },
}

export default animateOnScroll
